import { useEffect, useMemo } from 'react';
import { useGetData } from './useGetData';
import { isLoading, resolveAccount, isCachingAccount } from './utils';
export default function useInit({ skip = false }) {
    const query = useGetData({ skip });
    useEffect(() => {
        var _a, _b;
        if (isCachingAccount(query)) {
            const data = query.data;
            const accounts = (_a = data.companyUsers) !== null && _a !== void 0 ? _a : [];
            const account = resolveAccount(accounts, (_b = query.data) === null || _b === void 0 ? void 0 : _b.storedAccountId);
            query.updateQuery(() => (Object.assign(Object.assign({}, data), { account, accounts })));
        }
    }, [query]);
    return useMemo(() => (Object.assign(Object.assign({}, query), { loading: isLoading(query) })), [query]);
}
